import { TLoadable, createUnloaded, createLoading, createLoadErrored } from "../../../../sg-core";
import { ICategoryAction } from "../actions/categoryAction";
import ICategory from '../../interfaces/ICategory';
import { itemsToMappedIdList, appendUniqueToLodableIdList } from '../../utils/item.helpers'

export const defaultCategoryState: ICategoryState = {
    categories: {},
    categoryList: createUnloaded(),
};

export interface ICategoryState {
    categories: { [key: string]: ICategory }
    categoryList: TLoadable<number[]>;
}

export default function CategoryReducer(state = defaultCategoryState, action: ICategoryAction) {
    switch (action.type) {

        case "REQUEST_FETCH_CATEGORIES": {
            return {
                ...state,
                categoryList: createLoading(),
            };
        }

        case "SUCCESS_FETCH_CATEGORIES": {
            const parsedCategories = itemsToMappedIdList(action.payload.categories);
            return {
                ...state,
                categories: {
                    ...state.categories,
                    ...parsedCategories.mapping,
                },
                categoryList: appendUniqueToLodableIdList(state.categoryList, parsedCategories.ids),
            };
        }

        case "FAILURE_FETCH_CATEGORIES": {
            return {
                ...state,
                categoryList: createLoadErrored(action.payload.error),
            };
        }

        case "APPEND_TO_CATEGORY_LIST": {
            const parsed = itemsToMappedIdList(action.payload.categories);
            return {
                ...state,
                categories: { ...state.categories, ...parsed.mapping },
                categoryList: appendUniqueToLodableIdList(state.categoryList, parsed.ids),
            };
        }

        default: {
            return state;
        }
    }
}
